import React from "react";
import {
  CartesianGrid,
  Line,
  LineChart,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";
import _ from "lodash";

import {
  ThemeType,
  formatNumber
} from "src/library/utils";

import { GraphProps } from "./Graph";
import GraphToolTip from "./GraphToolTip";
import {
  determineInterval,
  formattedXAxisDate,
  getStroke
} from "./utils";

export interface GraphLineChartProps extends GraphProps {
  theme: ThemeType | null;
}

// Generates a Line Chart
const GraphLineChart: React.ReactFCWithChildren<GraphLineChartProps> = ({
  data,
  graphMetrics,
  theme,
  xAxis,
  toolTipValueType,
  containerWidth,
  hideLegend = false
}) => {
  const interval = React.useMemo(() => {
    return determineInterval(data.length);
  }, [ data ]);

  return (
    <ResponsiveContainer
      width="100%"
      height="100%"
    >
      <LineChart
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 0,
          bottom: 5
        }}
      >
        <CartesianGrid stroke={theme ? theme.colors.lightestGrey : "#eee"} />

        <XAxis
          angle={containerWidth && containerWidth < 300 ? -15 : 0}
          dataKey={xAxis.dataKey}
          interval={interval}
          tickFormatter={tickItem => tickItem instanceof Date ? formattedXAxisDate(tickItem, xAxis.dateFormat) : _.startCase(tickItem.replace(/[_-]/g, " "))}
        />

        <YAxis tickFormatter={tickItem => typeof tickItem === "number" ? formatNumber(tickItem, "short") : tickItem} />

        <Tooltip content={<GraphToolTip valueType={toolTipValueType} />} />

        {!hideLegend && (
          <Legend formatter={item => typeof item === "string" && _.startCase(item.replace(/[_-]/g, " "))} />
        )}

        {theme && (
          graphMetrics.map((metric, iteration) => (
            <Line
              key={metric.dataKey}
              dataKey={metric.dataKey}
              type="monotone"
              stroke={getStroke(iteration, theme)}
              connectNulls
            />
          ))
        )}

      </LineChart>
    </ResponsiveContainer>
  );
};

export default GraphLineChart;
